var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-preview-component ItemPreview" },
    [
      _c("CoverImg", { attrs: { src: _vm.imgURL, height_ratio: 1 } }, [
        _c("div", { staticClass: "item-content" }, [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c("DeleteBtn", {
                on: {
                  click: function($event) {
                    return _vm.$emit("delete")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.item.title || _vm.item.name) +
                "\n            "
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }